module.exports = __webpack_public_path__ + "static/img/customers_ul_bg.635099a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/customers_ul_bg.png
// module id = Kj+G
// module chunks = 1